import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
import n from "./index289.js";
const s = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(p, e, c, d, m, f) {
  return t(), o("svg", l, e[0] || (e[0] = [
    r("path", {
      "fill-rule": "evenodd",
      d: "m8.854 10.854 2.792 2.792a.5.5 0 0 0 .708 0l2.792-2.792a.5.5 0 0 0-.353-.854H9.207a.5.5 0 0 0-.353.854Z"
    }, null, -1)
  ]));
}
const w = /* @__PURE__ */ n(s, [["render", a]]);
export {
  w as default
};
